import React from "react";
import "./css/products.css";
import Product from "./Product";
// import rasam from "./rasam_powder.jpg";
// import tengol from "./rasam_powder.jpg";
// import vangi from "./rasam_powder.jpg";
// import methi from "./rasam_powder.jpg";
// import pchutney from "./rasam_powder.jpg";
// import chutney from "./rasam_powder.jpg";
// import bisi from "./rasam_powder.jpg";
// import mandakki from "./rasam_powder.jpg";
// import kayi_holige from "./rasam_powder.jpg";
// import sakkare_holige from "./rasam_powder.jpg";
// import puliyogare from "./rasam_powder.jpg";

function Products() {
  return (
    <div id="products" className="products">
      <h3 className="products_title">OUR PRODUCTS</h3>

      <div className="products_row">
        <div id="1" className="row_product">
          <Product
            id="1"
            title="Besan Laddoo"
            category="box"
            image="https://www.indianhealthyrecipes.com/wp-content/uploads/2019/08/besan-ladoo.jpg"
            price="90"
          />
        </div>
        <div id="2" className="row_product">
          <Product
            id="2"
            title="Puri Unde"
            category="box"
            image="https://m.media-amazon.com/images/I/41hzY651KAL._AC_UL480_QL65_.jpg"
            price="96"
          />
        </div>

        <div id="5" className="row_product">
          <Product
            id="5"
            title="Benne Murukku"
            category="powder"
            image="https://m.media-amazon.com/images/I/61Bhr+kmuUL._AC_UL480_QL65_.jpg"
            price="325"
          />
        </div>
        <div id="7" className="row_product">
          <Product
            id="7"
            title="Kadubu"
            category="box"
            image="https://i.ytimg.com/vi/uQtvOouNGeA/maxresdefault.jpg"
            price="72"
          />
        </div>
      </div>
      <div className="products_row">
        <div id="6" className="row_product">
          <Product
            id="6"
            title="Kajjaya"
            category="box"
            image="https://www.villageexpres.com/wp-content/uploads/2021/11/Nuvvula-Ariselu.webp"
            price="72"
          />
        </div>

        <div id="4" className="row_product">
          <Product
            id="4"
            title="Chakkuli"
            category="box"
            image="https://m.media-amazon.com/images/I/51oJb+Kz2TS._AC_UL480_QL65_.jpg"
            price="48"
          />
        </div>
        <div id="3" className="row_product">
          <Product
            id="3"
            title="Chivda"
            category="powder"
            image="https://krushikendra.com/image/cache/catalog/Homemade%20food/farali-poha2-800x800.png"
            price="280"
          />
        </div>
        <div id="23" className="row_product">
          <Product
            id="23"
            title="ಚೂಡಾ ಅವಲಕ್ಕಿ | Chivda (With Garlic)"
            category="powder"
            image="https://krushikendra.com/image/cache/catalog/Homemade%20food/farali-poha2-800x800.png"
            price="280"
          />
        </div>
      </div>
      <div className="products_row">
        <div id="9" className="row_product">
          <Product
            id="9"
            title="Mandakki"
            category="pack"
            image="https://www.indianveggiedelight.com/wp-content/uploads/2017/03/mandakki-usali-featured-500x375.jpg"
            price="65"
          />
        </div>
        <div id="24" className="row_product">
          <Product
            id="24"
            title="Mandakki (With Garlic)"
            category="pack"
            image="https://vegrecipesofkarnataka.com/assets/img/bellulli-mandakki/bellulli-mandakki-recipe.jpg"
            price="50"
          />
        </div>

        <div id="13" className="row_product">
          <Product
            id="13"
            title="Sugar Holige"
            category="box"
            image="https://cuisineindia.files.wordpress.com/2013/06/19-2-2013-139.jpg"
            price="132"
          />
        </div>
        <div id="12" className="row_product">
          <Product
            id="12"
            title="Coconut Holige"
            category="box"
            image="https://www.masalakorb.com/wp-content/uploads/2018/03/Coconut-Obbattu-Recipe-Kayi-Holige-V2.jpg"
            price="120"
          />
        </div>
      </div>
      <div className="products_row">
        <div id="17" className="row_product">
          <Product
            id="17"
            title="Chutney Powder"
            category="powder"
            image="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT-7wBmo0G3ZkIOG8cTC4YfLAuk72D3RDes5w&usqp=CAU"
            price="430"
          />
        </div>
        <div id="14" className="row_product">
          <Product
            id="14"
            title="Rasam Powder"
            category="powder"
            image="https://www.sharmispassions.com/wp-content/uploads/2013/07/rasampowder-1.jpg"
            price="630"
          />
        </div>
        <div id="15" className="row_product">
          <Product
            id="15"
            title="Sambar Powder"
            category="powder"
            image="https://m.media-amazon.com/images/I/51I4NPKCehL._AC_UL480_QL65_.jpg"
            price="630"
          />
        </div>
        <div id="22" className="row_product">
          <Product
            id="22"
            title="Puliyogare Mix"
            category="powder"
            image="https://i.ytimg.com/vi/3MUEqeTMpU4/maxresdefault.jpg"
            price="430"
          />
        </div>
      </div>
      <div className="products_row">
        <div id="18" className="row_product">
          <Product
            id="18"
            title=" Peanut Chutney Powder"
            category="powder"
            image="https://www.subbuskitchen.com/wp-content/uploads/2021/02/peanut-chutney-powder_web1.jpg"
            price="430"
          />
        </div>
        <div id="25" className="row_product">
          <Product
            id="25"
            title="Peanut Chutney Powder (With Garlic)"
            category="powder"
            image="https://www.subbuskitchen.com/wp-content/uploads/2021/02/peanut-chutney-powder_web1.jpg"
            price="430"
          />
        </div>

        <div id="19" className="row_product">
          <Product
            id="19"
            title="Chat masala"
            category="powder"
            image="https://farm8.staticflickr.com/7596/16773190125_650cc601b9_o.jpg"
            price="630"
          />
        </div>
        <div id="20" className="row_product">
          <Product
            id="20"
            title="Bharta Bengan Powder"
            category="powder"
            image="https://5.imimg.com/data5/JE/TG/MY-5320836/baingan-bharta-masala-powder-500x500.jpg"
            price="630"
          />
        </div>
      </div>
      <div className="products_row">
        <div id="21" className="row_product">
          <Product
            id="21"
            title="Gojju Powder"
            category="powder"
            image="https://www.itslife.in/wp-content/gallery/recipe-condiments/recipes-condiments-gojju-pudi-2.jpg"
            price="630"
          />
        </div>

        <div id="10" className="row_product">
          <Product
            id="10"
            title="Tengolu"
            category="box"
            image="https://i.ytimg.com/vi/M-knQi-t8S0/hqdefault.jpg"
            price="72"
          />
        </div>
        <div id="8" className="row_product">
          <Product
            id="8"
            title="Nippattu"
            category="box"
            image="https://m.media-amazon.com/images/I/61IJJ+JrXXL._AC_UL480_QL65_.jpg"
            price="48"
          />
        </div>
        <div id="16" className="row_product">
          <Product
            id="16"
            title="Menthya Powder"
            category="powder"
            image="https://5.imimg.com/data5/SELLER/Default/2021/2/OZ/DO/DQ/26951710/fenugreek-powder-500x500.png"
            price="430"
          />
        </div>
      </div>
    </div>
  );
}

export default Products;
